import { Link } from "react-router-dom";
import RequireCompany from "@/components/RequireCompany";
import PageHeader from "@/components/PageHeader";
import { Landmark, FileCheck2, Upload, Brain, BarChart3, Settings2 } from "lucide-react";

const tiles = [
  {
    to: "/banking/import-recommend",
    title: "AI Import + Auto Vouchers",
    desc: "Upload CSV / XLSX / PDF (incl. scanned). AI suggests the contra ledger for each row. Approve, then post in bulk. The system learns from your overrides.",
    icon: Brain,
    accent: "bg-purple-50 text-purple-700 group-hover:bg-purple-100",
    testid: "bank-tile-import-recommend",
  },
  {
    to: "/banking/recon-dashboard",
    title: "Reconciliation Dashboard",
    desc: "Imported, Matched, Unmatched, Pending and Duplicate transactions at a glance. Filter by ledger, date range and amount.",
    icon: BarChart3,
    accent: "bg-blue-50 text-blue-700 group-hover:bg-blue-100",
    testid: "bank-tile-recon-dashboard",
  },
  {
    to: "/banking/smart-settings",
    title: "Rule Management",
    desc: "Review, edit, activate/deactivate or bulk-delete learned bank-import rules. Every approved mapping becomes a rule for next time.",
    icon: Settings2,
    accent: "bg-amber-50 text-amber-700 group-hover:bg-amber-100",
    testid: "bank-tile-smart-settings",
  },
  {
    to: "/banking/reconciliation",
    title: "Bank Reconciliation",
    desc: "Reconcile bank-statement entries with your books. See book balance vs statement balance live.",
    icon: Landmark,
    testid: "bank-tile-reconciliation",
  },
  {
    to: "/banking/cheques",
    title: "Cheque Register",
    desc: "All issued cheques with Pending / Cleared / Bounced status. Print on standard CTS-2010 cheque.",
    icon: FileCheck2,
    testid: "bank-tile-cheques",
  },
  {
    to: "/banking/import-statement",
    title: "Match Statement (Legacy)",
    desc: "Upload CSV and match against existing vouchers — older flow without AI recommendations.",
    icon: Upload,
    testid: "bank-tile-import-statement",
  },
];

function Inner() {
  return (
    <>
      <PageHeader title="Banking" subtitle="Reconciliation, cheque register, and printing" />
      <div className="p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl" data-testid="banking-index">
          {tiles.map((t) => (
            <Link
              key={t.to}
              to={t.to}
              className="block border border-gray-200 rounded bg-white p-5 hover:border-blue-400 hover:shadow-sm transition group"
              data-testid={t.testid}
            >
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded flex items-center justify-center ${t.accent || "bg-blue-50 text-blue-700 group-hover:bg-blue-100"}`}>
                  <t.icon className="w-5 h-5" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{t.title}</div>
                  <div className="text-xs text-gray-500 mt-1">{t.desc}</div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}

export default function Banking() {
  return (
    <RequireCompany>
      <Inner />
    </RequireCompany>
  );
}
